import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { getUserData } from '../../../api/auth';
import {
  SynButtonComponent,
  SynOptionComponent,
  SynSelectComponent,
  SynTextareaComponent,
} from '@synergy-design-system/angular';
import { StateService } from '../../../api/state';

@Component({
  selector: 'app-client-scope-evaluation',
  template: `
    <div class="flex-row gap-2 align-center margin-bottom-1">
      <p i18n="@@token-preview-description">
        Show example tokens for the selected client. This is useful for testing the client's scope evaluation.
      </p>
    </div>

    <div class="flex-row gap-2 align-center margin-bottom-1">
      <syn-select style="width:40%"
                  label="Scopes"
                  [(value)]="scopes"
                  [multiple]="true"
                  [clearable]="true">
        <syn-option value="profile">profile</syn-option>
        <syn-option value="openid">openid</syn-option>
        <syn-option value="customer-data">customer-data</syn-option>
        <syn-option value="sick-employee">sick-employee</syn-option>
      </syn-select>
      <syn-select
        style="width:40%"
        label="User"
        i18n-label="@@user"
        [(value)]="userId"
      >
        <syn-option [value]="authUser.id"> {{ authUser.username }}</syn-option>
        @for (user of users(); track user.id) {
          <syn-option [value]="user.id">{{ user.username }}</syn-option>
        }
      </syn-select>
      <syn-button style="width:20%; margin-top:auto" (click)="onClick()"
                  data-e2e="btn-get-tokens">
        <span i18n="@@get-tokens">Get Tokens</span>
      </syn-button>
    </div>

    <!-- </form> -->
    <div class="flex-row gap-2 align-center margin-bottom-1">
      <div class="flex" style="width: 50%">
        <p>Access Token</p>
        <syn-textarea
          [rows]="25"
          [spellcheck]="false"
          [readonly]="true"
          [(value)]="accessToken" />
      </div>
      <div class="flex" style="width: 50%">
        <p>ID Token</p>
        <syn-textarea
          [rows]="25"
          [spellcheck]="false"
          [readonly]="true"
          [(value)]="idToken" />
      </div>
    </div>
  `,
  styles: [
    `
      syn-textarea::part(textarea) {
        font-family: monospace;
      }
    `,
  ],
  imports: [SynButtonComponent, SynSelectComponent, SynOptionComponent, SynTextareaComponent],
})
export class ScopeEvaluationComponent implements OnInit {
  id = inject(ActivatedRoute).snapshot.params['id'];
  api = inject(ServicePortalApi);
  state = inject(StateService);
  router = inject(Router);

  scopes = signal(['profile', 'openid']);
  authUser = getUserData();
  userId = signal(this.authUser.id);

  users = this.state.testUsers;

  idToken = signal('...');
  accessToken = signal('...');

  onClick() {
    console.log(this.scopes());

    this.api.getScopeEvaluation(this.id, this.userId(), this.scopes().join('+'), (value) => {
      if (this.scopes().includes('openid')) {
        this.idToken.set(JSON.stringify(value.idToken, null, 2));
      } else {
        this.idToken.set('scope openid missing');
      }
      this.accessToken.set(JSON.stringify(value.accessToken, null, 2));
    });
  }

  ngOnInit() {
    this.state.queryTestUsers();
  }
}
